import React from 'react';
import Select from "react-select";
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UInput from "ubs-framework/v2/UInput";

const ColumnMatchTable = React.memo((props) => {
    return (
        <React.Fragment>
            <UCustomScrollBar>
                <div className="u_table-resource u_table-resource-nowrap u_table-resource-hover u_table-resource-no-sticky u_text-left">
                    <table>
                        <thead className="u_table-resource-header">
                        <tr>
                            <th>Column name in EXCEL</th>
                            <th>First data record in EXCEL</th>
                            <th>Match to field</th>
                        </tr>
                        </thead>
                        <tbody>
                        {props?.updatedFields?.map((data, i) => {
                            return (
                                <tr key={i} className={`${!props?.ie?.HEADER?.find(e => e?.key === data?.mainKey) ? 'u_un-active' : ''}`}>
                                    <td>{data?.fileKey} {data?.isRequired && <span className="u_error">*</span>}</td>
                                    <td className="u_ws-initial"><p className="u_small-font u_one-line u_w-200">{data?.value}</p></td>
                                    <td className="">
                                        <UInput label="Match To Field" select selectValue={props?.ie?.HEADER?.find(e => e?.key === data?.mainKey)}
                                                className={`u_my-5 ${!props?.ie?.HEADER?.find(e => e?.key === data?.mainKey) ? 'u_input-error' : ''}`}>
                                            <Select
                                                className={`u_input-select-inner u_input-small`}
                                                classNamePrefix="u_select"
                                                options={props?.ie?.HEADER ?? []}
                                                placeholder=" "
                                                value={props?.ie?.HEADER?.find(e => e?.key === data?.mainKey)}
                                                name={`type-${i}`}
                                                onChange={(e) => props?.handle.change(e, data?.fileKey)}
                                                maxMenuHeight={120}
                                                menuPlacement="auto"
                                            />
                                        </UInput>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </UCustomScrollBar>
        </React.Fragment>
    );
});

export default ColumnMatchTable;
